import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS } from 'constants/table';
import { formatDate } from 'utils';

function DiagnosticTable({
  items,
  onRowClick,
  perPage,
  totalRows,
  setPagination,
  loading,
}) {
  const columns = [
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      render: (i) => formatDate(i, 'DD.MM.YYYY'),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items.items}
      pagination={{
        pageSize: perPage,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      loading={loading}
      onChange={setPagination}
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
    />
  );
}

export default DiagnosticTable;
